var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar-item" },
    [
      _c(
        "el-menu-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.item.children && _vm.item.toShow,
              expression: "!item.children && item.toShow",
            },
          ],
          key: _vm.item.name + "m",
          staticClass: "has-no-children",
          attrs: { index: _vm.item.name + "p" },
          on: {
            click: function ($event) {
              return _vm.clickMenu(_vm.item)
            },
          },
        },
        [
          _vm.item.parentId === 0
            ? _c("i", { class: `el-icon-${_vm.item.icon}` })
            : _vm._e(),
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.item.label) + " "),
          ]),
        ]
      ),
      _c(
        "el-submenu",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item.children && _vm.item.toShow,
              expression: "item.children && item.toShow",
            },
          ],
          key: _vm.item.name + "s",
          ref: "subMenu",
          attrs: { index: _vm.item.name + "p", "popper-append-to-body": "" },
        },
        [
          _c("template", { slot: "title" }, [
            _c("i", { class: `el-icon-${_vm.item.icon}` }),
            _c("span", { attrs: { slot: "title" }, slot: "title" }, [
              _vm._v(_vm._s(_vm.item.label)),
            ]),
          ]),
          _vm._l(_vm.item.children, function (child) {
            return _c("sidebar-item", {
              key: child.path + "i",
              staticClass: "nest-menu",
              attrs: { item: child, "base-path": child.path },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }